<template>
  <div>
    <b-modal
      id="invite-member"
      ref="invite-member"
      size="invite-member"
      centered
      :no-close-on-backdrop="showPurchaseSeats"
      hide-footer
      hide-header
      @hide="onModalHide"
    >
      <span v-if="discard" class="overlay" />
      <div class="modal-head" :class="{ seats: showPurchaseSeats }">
        <h2 v-if="!showPurchaseSeats" class="modal-title">
          {{ label.get("invite_new_members") }}
        </h2>
        <h2 v-if="showPurchaseSeats" class="modal-title">
          {{ label.get("subscription_purchase_additional_seats") }}
        </h2>

        <a
          href="/#/settings/manage-team"
          class="manage-team-anchor"
          @click="onModalHide"
        >
          <i class="atto atto-rdir-arrow-b" />
          {{ label.get("manage_team") }}
        </a>
      </div>
      <div
        v-if="!showNotAccountOwner && !showResumeSubscription"
        class="content-wrapper hasScroll"
        :class="{ seats: showPurchaseSeats }"
      >
        <perfect-scrollbar>
          <p v-if="showPurchaseSeats" class="seats-desc">
            {{
              label.get("subscription_purchase_additional_seats_description")
            }}
          </p>
          <div class="head-labels">
            <div class="label email">
              <p>
                {{ label.get("email_address") }}
              </p>
            </div>
            <div class="label">
              <p>
                {{ label.get("role") }}
              </p>
            </div>
          </div>
          <div v-for="(item, idx) in invites" :key="idx" class="field-row">
            <div class="email-wrap">
              <input
                v-model="item.email"
                type="email"
                ref="email"
                :class="{ error: item.error }"
                :placeholder="label.get('enter_email_address') + '...'"
                class="atto-input"
              />
            </div>
            <div class="role-wrap">
              <select-dropdown-component
                :value="item.role"
                :index="idx"
                placeholder="Select Role:"
                :options="roles"
                @onOptionSelected="onRoleSelected"
              />
            </div>
            <button
              v-if="showPurchaseSeats && !item.deleting"
              class="delete-member"
              @click="deleteInvite(item)"
            >
              <i class="atto atto-delete" />
            </button>
            <transition v-if="showPurchaseSeats && !item.deleting" name="fade">
              <div v-if="item.confirm_delete" class="confirm-delete">
                <span class="confirm-msg">{{ label.get("are_you_sure") }}</span>
                <button class="confirm-delete-btn" @click="confirmDelete(item)">
                  {{ label.get("delete") }}
                </button>
                <button
                  class="cancel-delete"
                  @click="cancelConfirmDelete(item)"
                >
                  <i class="atto atto-close-btn" />
                </button>
              </div>
            </transition>
          </div>
          <button
            v-if="!showPurchaseSeats"
            class="add-new-btn"
            type="button"
            @click="addAnotherMember"
          >
            <i class="atto atto-add-more" />
            {{ label.get("invite_add_another_member") }}
          </button>
        </perfect-scrollbar>
      </div>
      <hr class="hr-purchase" v-if="showPurchaseSeats" />
      <div
        v-if="showPurchaseSeats"
        class="additional-seats-form manage-team-seats-form"
      >
        <div class="form-head">
          <span class="no">{{
            label.get("subscription_number_of_users")
          }}</span>
          <span class="price">{{
            label.get("subscription_price_per_user")
          }}</span>
          <span class="total">{{ label.get("subscription_subtotal") }}</span>
        </div>
        <div class="form-fields">
          <span class="no">{{ purchaseSeats }}</span>
          <span class="price">${{ proratedCostPerUser }}</span>
          <span class="total">${{ subTotal.toFixed(2) }}</span>
        </div>
        <div class="row">
          <div class="purchase-row">
            <span class="price">{{ label.get("subscription_tax") }}</span>
            <div class="tax-loading-holder" v-if="loading">
              <div class="loading-spinner small" />
            </div>
            <span class="total">${{ taxAmount }}</span>
          </div>
        </div>
        <div class="row">
          <div class="purchase-row total-amount-row">
            <span class="price">{{
              label.get("subscription_total_amount")
            }}</span>
            <div class="amount-loading-holder" v-if="loading">
              <div class="loading-spinner small" />
            </div>
            <span class="total">${{ totalAmount }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="showNotAccountOwner"
        class="content-wrapper"
        :class="{ seats: showPurchaseSeats }"
      >
        <p class="seats-desc">
          {{
            label.get(
              "you_dont_have_any_available_seats_in_your_account_subscription_plan"
            )
          }}
        </p>
      </div>
      <div
        v-if="showResumeSubscription"
        class="content-wrapper"
        :class="{ seats: showPurchaseSeats }"
      >
        <p class="seats-desc">
          {{
            label.get(
              "your_subscription_is_set_to_cancel_at_the_end_of_your_current_billing_period"
            )
          }}
        </p>
      </div>
      <!--<div class="additional-seats-form manage-team-seats-form">
            <div class="form-head">
              <span class="no">{{label.get('subscription_number_of_users')}}</span>
              <span class="price">{{label.get('subscription_price_per_user')}}</span>
              <span class="total">{{label.get('subscription_subtotal')}}</span>
            </div>
            <div class="form-fields">
              <span class="numb-of-users">2</span>
              <span class="price">${{ proratedCostPerUser.toFixed(2) }}</span>
              <span class="total">${{ subTotal }}</span>
            </div>

            <span
                v-if="error"
                class="error-message"
            >{{ errorMessage }}</span>
          </div>-->
      <div
        class="modal-footer"
        v-bind:class="{
          'sm-footer':
            !showPurchaseSeats &&
            !showNotAccountOwner &&
            !showResumeSubscription,
        }"
      >
        <!--<div
                        v-if="showPurchaseSeats"
                        class="form-disclaimer top"
                >
                    <p>
                        {{label.get('subscription_purchase_additional_seats_prorated_amount')}}
                    </p>
                </div>-->
        <p v-if="invalidEmails" class="alert-message" v-html="errorMessage" />
        <div class="form-buttons">
          <button type="reset" class="atto-btn cancel" @click="cancelInvite">
            {{ label.get("cancel") }}
          </button>
          <button
            v-if="
              !showPurchaseSeats &&
                !showNotAccountOwner &&
                !showResumeSubscription
            "
            type="submit"
            class="atto-btn submit"
            @click="sendInvites"
          >
            {{ label.get("send_invites") }}
          </button>
          <button
            v-if="showPurchaseSeats"
            type="submit"
            class="atto-btn submit"
            @click="completePurchase"
          >
            {{ label.get("subscription_complete_purchase") }}
          </button>
          <button
            v-if="showResumeSubscription"
            type="submit"
            class="atto-btn submit"
            @click="reactivateSubscription"
          >
            {{ label.get("reactivate_subscription") }}
          </button>
        </div>
        <div class="form-disclaimer" v-if="showPurchaseSeats">
          <p class="top">
            {{
              label.get(
                "subscription_purchase_additional_seats_prorated_amount"
              )
            }}
          </p>
          <p class="bottom">
            {{
              label.get(
                "subscription_purchase_additional_seats_description_one"
              )
            }}
            {{
              label.get(
                "subscription_purchase_additional_seats_description_two"
              )
            }}
          </p>
        </div>
      </div>

      <div
        class="links"
        v-if="
          !showPurchaseSeats &&
            !showNotAccountOwner &&
            !showResumeSubscription &&
            shareInviteEnabled
        "
      >
        <div v-if="shareInviteUrl">
          <p>{{ label.get("share_invite_link") }}</p>
        </div>
        <div class="share-link" v-if="shareInviteUrl">
          <!--  <label>{{label.get('share_link')}}</label>-->
          <div class="link-holder">
            <img src="/images/link-icon.svg" />
            <input
              type="text"
              id="testing-code"
              readonly
              :value="shareInviteUrl"
              @click="copyLinkCode($event)"
            />
          </div>
          <b-tooltip :show.sync="show" target="testing-code" placement="top">
            {{ label.get("copied") }}
          </b-tooltip>
          <span class="copy-btn" @click="copyLinkCode($event)">{{
            label.get("copy_link")
          }}</span>
        </div>
        <div class="deactivate-link" v-if="shareInviteUrl">
          <a
            href="javascript:void(0);"
            @click="deactivateLink()"
            class="deactivate"
            >{{ label.get("deactivate_link") }}</a
          >
        </div>
        <div v-if="!shareInviteUrl">
          <p>{{ label.get("create_invite_link_description") }}</p>
          <a
            href="javascript:void(0);"
            @click="activateLink()"
            class="activate"
            >{{ label.get("activate_link") }}</a
          >
        </div>
      </div>
      <div v-if="discard" class="discard-invite">
        <div class="field-row">
          <h4>{{ label.get("invite_discard_new_invites_modal_title") }}</h4>
          <p>
            {{ label.get("invite_discard_new_invites_modal_body") }}
          </p>
        </div>
        <div class="field-footer">
          <button class="cancel atto-btn" @click="cancelDiscard">
            {{ label.get("cancel") }}
          </button>
          <button class="atto-btn discard" @click="confirmDiscard">
            {{ label.get("discard") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SelectDropdownComponent from "../components/SelectDropdownComponent";
import InviteService from "../services/InviteService";
import BillingService from "../../features/settings/billing/services/BillingService";
import UtilsService from "../services/UtilsService";
import CompanyService from "../../features/settings/company/services/CompanyService";
import SubscriptionService from "../../features/subscription/services/SubscriptionService";

export default {
  name: "InviteMemberComponent",
  components: {
    SelectDropdownComponent,
  },
  data() {
    return {
      showPurchaseSeats: false,
      showNotAccountOwner: false,
      showResumeSubscription: false,
      purchaseSeats: 0,
      proratedCostPerUser: 0,
      proratedTaxPerUser: 0,
      isFirstPurchaseStripeTax: false,
      subTotal: 0,
      taxAmount: 0,
      totalAmount: 0,
      invalidEmails: false,
      discard: false,
      errorMessage: "",
      loading: false,
      payInvoiceRetryCount: 1,
      invites: [
        {
          id: null,
          email: "",
          role: 3,
          error: false,
        },
      ],
      roles: [
        {
          value: 1,
          label: this.label.get("admin"),
        },
        {
          value: 2,
          label: this.label.get("manager"),
        },
        {
          value: 3,
          label: this.label.get("employee"),
        },
      ],
      show: false,
      // shareInviteEnabled : this.$store.state.shareInviteEnabled,
      // shareInviteUrl: this.$store.state.shareInviteUrl,
    };
  },
  computed: {
    shareInviteUrl() {
      return this.$store.state.shareInviteUrl;
    },
    shareInviteEnabled() {
      return this.$store.state.shareInviteEnabled;
    },
  },
  mounted() {
    this.$refs["invite-member"].show();
    this.$root.$on(
      "hideReactivateSubscription",
      this.hideReactivateSubscription
    );
  },
  methods: {
    addAnotherMember() {
      let emptyFields = false;
      this.invites.forEach((item) => {
        if (item.email.trim() === "") {
          emptyFields = true;
        }
      });
      if (!emptyFields) {
        this.invites.push({
          id: null,
          email: "",
          role: 3,
          error: false,
        });
      }

      const _this = this;
      setTimeout(function() {
        _this.$nextTick(() => {
          const last = _this.$refs.email.pop();
          last.focus();
        });
      }, 100);
    },
    onRoleSelected(option, index) {
      this.invites[index].role = option.value;
    },
    sendInvites() {
      this.errorMessage = "";
      this.invalidEmails = false;
      this.resetErrors();
      if (!this.validateEmails()) {
        this.errorMessage = this.label.get("please_add_a_valid_email");
        this.invalidEmails = true;
        return;
      }

      const invites = this.invites.filter((item) => {
        return item.email !== "";
      });
      const data = invites.map((item, idx) => {
        item.index = idx;
        return item;
      });

      this.$store.commit("showLoading");
      InviteService.sendInvites({
        invites: data,
      })
        .then((result) => {
          if (result.status === 201) {
            this.purchaseSeats = result.data.purchaseSeats;

            this.proratedCostPerUser = result.data.proratedCostPerUser;
            this.proratedTaxPerUser = result.data.proratedTaxPerUser;
            this.isFirstPurchaseStripeTax = result.data.isFirstPurchaseStripeTax;

            this.subTotal = this.purchaseSeats * result.data.proratedCostPerUser;

            this.taxAmount = this.purchaseSeats * this.proratedTaxPerUser;
            this.totalAmount = (this.subTotal + this.taxAmount).toFixed(2);
            this.taxAmount = this.taxAmount.toFixed(2);

            //this.calculateTax(this.subTotal, this.purchaseSeats);

            //this.totalAmount = (this.purchaseSeats * this.proratedCostPerUser).toFixed(2);

            this.invites = result.data.invites.map((item, idx) => {
              item.index = idx;
              item.deleting = false;
              item.confirm_delete = false;
              return item;
            });

            this.showPurchaseSeats = true;
          } else if (result.status === 202) {
            this.showNotAccountOwner = true;
          } else if (result.status === 210) {
            this.showResumeSubscription = true;
          } else {
            this.$root.$emit("hideInviteMembers");
            this.$root.$emit("reloadInvites");
            this.$awn.success(result.data.message);
          }
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          if (error.response.status === 422) {
            const errors = error.response.data;
            errors.forEach((err) => {
              this.invites[err.index].error = true;
              this.errorMessage += err.message + "<br>";
            });
            this.invalidEmails = true;
          } else if (error.response.status === 403) {
            this.$root.$emit("noSubscription");
          }
        });
    },
    // calculateTax(amount, quantity) {
    //   this.taxAmount = "";
    //   this.totalAmount = "";
    //   this.loading = true;
    //   SubscriptionService.getTaxAmountForPurchaseSeats(amount, quantity)
    //     .then((result) => {
    //       debugger;
    //       this.taxAmount = result.taxAmount;
    //       this.totalAmount = (amount + this.taxAmount).toFixed(2);
    //       this.loading = false;
    //     })
    //     .catch((error) => {
    //       debugger;
    //       this.taxAmount = 0;
    //       this.totalAmount = amount.toFixed(2);
    //       this.loading = false;
    //       console.log(error);
    //     });
    // },
    completePurchase() {
      this.errorMessage = "";
      this.invalidEmails = false;
      this.resetErrors();
      if (!this.validateEmails()) {
        this.errorMessage = this.label.get("please_add_a_valid_email");
        this.invalidEmails = true;
        return;
      }

      this.$store.commit("showLoading");
      BillingService.purchaseSeats({
        invites: this.invites,
        isFirstPurchaseStripeTax: this.isFirstPurchaseStripeTax
      })
        .then((result) => {
          //this.payInvoice(result.data.invoice_id);
          this.$store.commit("hideLoading");
          this.$root.$emit("hideInviteMembers");
          this.$root.$emit("reloadInvites");
          this.$awn.success(this.label.get('message_invitations_sent_successfully'));
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },
    payInvoice(invoiceId) {
      debugger;
      BillingService.payInvoice({
        invoice_id: invoiceId,
        retry_count: this.payInvoiceRetryCount
      }).then((result) => {
        debugger;
        this.$store.commit("hideLoading");
        this.$root.$emit("hideInviteMembers");
        this.$root.$emit("reloadInvites");
        this.$awn.success(this.label.get('message_invitations_sent_successfully'));
      }).catch((error) => {
        debugger;
        console.log(error.response);
        if(error.response.status !== 423) {
          this.$store.commit("hideLoading");
          this.errorMessage = error.response.data.message;
          this.invalidEmails = true;
        } else if(this.payInvoiceRetryCount < 10) {
          this.payInvoiceRetryCount++;
          setTimeout(() => {
            this.payInvoice(invoiceId);
          }, 1000);
        }
      });
    },
    reactivateSubscription() {
      this.$root.$emit("showReactivateSubscription");
    },
    hideReactivateSubscription(reactivated) {
      if (reactivated) {
        this.showResumeSubscription = false;
        this.sendInvites();
      }
    },
    onModalHide() {
      this.$root.$emit("hideInviteMembers");
    },
    deleteInvite(item) {
      item.confirm_delete = true;
    },
    confirmDelete(item) {
      item.deleting = true;
      InviteService.deleteInvite(item.id)
        .then((result) => {
          const index = this.invites.indexOf(item);
          this.invites.splice(index, 1);
          if (this.invites.length === 0) {
            this.$root.$emit("hideInviteMembers");
          }
          this.purchaseSeats = this.invites.length;
          this.totalAmount = (
            this.purchaseSeats * this.proratedCostPerUser
          ).toFixed(2);
        })
        .catch((error) => {
          item.deleting = false;
        });
    },
    cancelConfirmDelete(item) {
      item.confirm_delete = false;
    },
    cancelInvite: function() {
      if (this.showPurchaseSeats) {
        this.discard = true;
      } else {
        this.$refs["invite-member"].hide();
      }
    },
    cancelDiscard() {
      this.discard = false;
    },
    confirmDiscard() {
      this.invites.forEach((item) => {
        InviteService.deleteInvite(item.id, false)
          .then(() => {})
          .catch(() => {});
      });

      this.$refs["invite-member"].hide();
      this.$root.$emit("hideInviteMembers");
    },
    resetErrors() {
      this.invites.forEach((item) => {
        item.error = false;
      });
    },
    validateEmails() {
      let validEmails = true;
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      let emptyEmails = "";
      this.invites.forEach((item) => {
        emptyEmails += item.email.trim();
      });
      if (emptyEmails.trim() === "") {
        this.invites[0].error = true;
        return false;
      }

      this.invites.forEach((item) => {
        if (item.email.trim() !== "" && !regex.test(item.email.trim())) {
          item.error = true;
          validEmails = false;
        }
      });

      return validEmails;
    },
    copyLinkCode(event) {
      let linkCodeToCopy = document.querySelector("#testing-code");
      linkCodeToCopy.setAttribute("type", "text");
      linkCodeToCopy.select();
      document.execCommand("copy");
      debugger;
      const _this = this;
      _this.show = true;
      setTimeout(() => {
        _this.show = false;
      }, 2000);
    },
    deactivateLink() {
      CompanyService.deactivateShareInvite()
        .then(() => {
          this.$store.state.shareInviteUrl = null;
        })
        .catch(() => {
          this.$store.commit("hideLoading");
        });
    },
    activateLink() {
      CompanyService.activateShareInvite()
        .then((result) => {
          this.$store.state.shareInviteUrl = result.url;
        })
        .catch(() => {
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tabletAndMobile {
  @media (max-width: 767px) {
    @content;
  }
}
/* End of: @media queries */
.modal-invite-member .modal-content .content-wrapper > .ps {
  padding-right: 0 !important;
}

span.overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
}

hr.hr-purchase {
  margin: 0 !important;
}

.modal-head {
  padding: 48px 48px 0;
  position: relative;

  h2.modal-title {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: #262626;
  }

  a.manage-team-anchor {
    position: absolute;
    right: 48px;
    top: 48px;
    width: 160px;
    font-size: 0.8125rem;
    line-height: 1.5rem;
    font-family: $roboto-font;
    color: $atto-font-color;
    font-weight: 500;
    display: flex;
    align-items: center;
    height: 30px;
    @include base-transition(ease color 0.15s);

    i {
      font-size: 0.6875rem !important;
      color: $atto-font-color;
      width: 24px;
      height: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin: 0 3px 0 33px;
      @include base-transition(ease color 0.15s);
    }

    &:hover {
      color: $atto-green;

      i {
        color: $atto-green;
      }
    }
  }
}

.modal-invite-member {
  max-width: 586px !important;
  width: 100% !important;

  .modal-content {
    .modal-body {
      padding: 0;

      .manage-team-seats-form {
        margin-top: 0;
        padding: 26px 48px;
        position: relative;
        display: flex;
        flex-flow: column;
        padding-bottom: 0 !important;

        &:before {
          content: none;
        }

        .form-head {
          display: flex;
          padding: 5px 12px;
          flex-direction: row;
          border: 1px solid #efefef;
          background-color: #fafafa;
          justify-content: space-between;

          span {
            font-size: 0.625rem !important;
            line-height: 0.6875rem !important;
            font-family: "Roboto", sans-serif;
            letter-spacing: 0.5px !important;
            font-weight: 500;
            color: $atto-not-active;
            text-transform: uppercase;

            &.numb-of-users {
              width: 100px !important;
            }
          }
        }

        .form-fields {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 17px 12px;
          border-bottom: 2px solid #efefef;

          span {
            display: inline-flex;
            border: 0;
            width: 35px !important;
            font-size: 1rem;
            line-height: 1.5rem;
            color: #262626;
            font-family: "Roboto", sans-serif;
            justify-content: flex-start !important;

            &:last-child {
              justify-content: flex-end !important;
            }
          }

          input.atto-input {
            display: inline-flex;
            /*border: none;*/
            /*padding: 6px 12px;*/
            width: 58px;
            font-size: 1rem;
            line-height: 1.5rem;
            color: #262626;
            font-family: "Roboto", sans-serif;
            text-align: left !important;

            /* Disabling Spinners */
            -webkit-appearance: none;
            -moz-appearance: textfield;
            margin-right: 36px;

            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }
        .row {
          float: left;
          width: 100%;
          .purchase-row {
            width: 50.5%;
            /*display: flex;
                    justify-content: space-between;*/
            margin-left: auto;
            padding: 16px 0;
            display: block;

            span {
              font: 400 1rem/1.5rem "Roboto";

              &.price {
                float: left;
              }
              &.total {
                float: right;
              }
            }
            &.total-amount-row {
              padding: 0;
              span {
                font-weight: 500;
              }
            }
          }
          .tax-loading-holder {
            /* display: flex;*/
            display: inline-block;
            float: right;
            width: 18px;
            height: 18px;
            margin: 2px -16px 0 7px;
            .loading-spinner {
              &.small {
                margin: -8px auto 0;
                position: relative;
                left: 0;
              }
            }
          }
          .amount-loading-holder {
            /*    display: flex;*/
            width: 18px;
            height: 18px;
            /*       margin: 0 -15px 0 10px;*/
            display: inline-block;
            float: right;
            margin: 0 -15px 0px 7px;
            .loading-spinner {
              &.small {
                margin: -8px auto 0;
                position: relative;
                left: 0;
              }
            }
          }
        }
      }

      .content-wrapper {
        padding: 14px 48px;
        display: flex;
        flex-direction: column;

        p.seats-desc {
          font-size: 14px !important;
          line-height: 20px !important;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
          margin-bottom: 16px !important;
        }

        .head-labels {
          display: flex;
          flex-direction: row;
          margin-bottom: 4px;

          .label {
            display: inline-flex;
            flex-grow: 1;

            p {
              color: $atto-not-active;
              font: $roboto-medium 0.6875rem/0.8125rem $roboto-font;
              margin-bottom: 0;
              letter-spacing: 0.6px;
              text-transform: uppercase;
            }

            &.email {
              flex-grow: 0;
              width: 320px;
              margin-right: 16px;
            }
          }
        }

        .field-row {
          display: flex;
          flex-direction: row;
          @include tabletAndMobile {
            flex-direction: column;
          }
          align-items: center;
          position: relative;

          input {
            border: 2px solid $atto-light-grey;
            padding: 8px 12px;
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            color: $atto-font-color;
            width: 100%;
            -webkit-appearance: none;
            border-radius: 0;
            @include base-transition(ease all 0.1s);

            &::-webkit-input-placeholder {
              color: $atto-font-color;
            }
          }

          input.error {
            border: 2px solid $atto-red;
          }

          .email-wrap {
            width: 320px;
            @include tabletAndMobile {
              width: 100%;
            }
            margin-right: 16px;

            input:focus {
              border-color: #c7c7c7;
            }
          }

          .role-wrap {
            display: inline-flex;
            flex-grow: 1;
            width: 154px;
            @include tabletAndMobile {
              width: 100%;
              margin-top: 8px;
            }

            .select-heading {
              flex-direction: row;

              i {
                font-size: 14px;
                color: $atto-dark-grey;
              }

              span {
                min-width: inherit;
                font-weight: 400;
                color: $atto-font-color;
              }
            }
          }

          .member-roles {
            display: inline-flex;
            align-items: center;
            border: 2px solid $atto-light-grey;
            padding: 8px;
            width: 160px;
            position: relative;
            cursor: pointer;

            .role-filters {
              display: flex;
              width: 100%;

              i.atto-u-arrow-b,
              i.atto-d-arrow-b {
                font-size: 12px;
                color: #c9c9c9;
                margin-left: auto;
                margin-right: 8px;
              }

              .selected-role {
                display: inline-flex;
                align-items: center;
                width: 100%;

                span.selected-options {
                  color: #262626;
                  font-family: $roboto-font;
                  font-weight: 400;
                  font-size: 0.875rem;
                  line-height: 1.2rem;
                  display: inline-flex;
                  flex-grow: 1;
                }
              }

              .dropdown-options {
                position: absolute;
                top: -8px;
                left: 0;
                width: 100%;
                box-shadow: 0 0 10px 0 #c7c7c7;
                background-color: #fff;
                z-index: 11;

                .title {
                  padding: 16px 8px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  border-bottom: 2px solid #efefef;

                  p {
                    flex-grow: 1;
                    margin-bottom: 0;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                    font-family: $roboto-font;
                    color: $atto-font-color;
                    font-weight: 400;
                  }
                }

                .roles-list {
                  ul {
                    padding: 8px 0;
                  }

                  li {
                    display: inline-flex;
                    padding: 8px;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                    font-family: $roboto-font;
                    color: $atto-font-color;
                    font-weight: 400;
                    width: 100%;
                    align-items: center;
                    cursor: pointer;

                    &:hover {
                      background-color: #f7f7f7;
                    }
                  }
                }
              }
            }
          }

          button.delete-member {
            width: 24px;
            height: 24px;
            margin-left: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;

            i {
              width: 24px;
              height: 24px;
              color: $atto-dark-grey;
              font-size: 20px;
            }
          }

          .atto-select {
            margin-right: 0;
            @include tabletAndMobile {
              width: 100%;
            }
            .select-heading {
              width: 154px;
              @include tabletAndMobile {
                width: 100%;
              }
              flex-direction: row;
              @include base-transition(ease all 0.1s);

              span {
                flex-grow: 1;
                display: inline-flex;
              }

              i {
                @include base-transition(ease all 0.1s);
              }

              &:hover {
                border-color: #c7c7c7;

                i {
                  color: #c7c7c7;
                }
              }
            }

            .select-options {
              .heading {
                i {
                  margin-right: 0;
                  color: #c7c7c7;
                }
              }
            }
          }

          .confirm-delete {
            position: absolute;
            right: 0;
            top: 0;
            background-color: #fff;
            width: 193px;
            height: 40px;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: flex-end;
            padding-left: 0px;

            .confirm-msg {
              font-size: 0.875rem;
              line-height: 1.75rem;
              font-family: "Roboto", sans-serif;
              font-weight: 400;
              color: #262626;
            }

            .confirm-delete-btn {
              font-size: 0.875rem;
              line-height: 1.75rem;
              font-family: "Roboto", sans-serif;
              font-weight: 500;
              color: #262626;
              margin-left: 12px;
              padding: 0;
              cursor: pointer;
            }

            .cancel-delete {
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 24px;
              padding: 0;
              cursor: pointer;

              i {
                font-size: 14px;
                color: #c7c7c7;
                @include base-transition(ease color 0.15s);
              }

              &:hover {
                i {
                  color: $atto-not-active;
                }
              }
            }
          }
        }

        button.add-new {
          font-size: 0.75rem;
          line-height: 1.25rem;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
          color: $atto-teal;
          margin-left: 14px;
          margin-bottom: 16px;
          flex-grow: 0;
          padding: 0;
          text-align: left;
          @include base-transition(ease all 0.1s);

          &:hover {
            color: #0ac1bf;
          }
        }

        &.seats {
          padding-top: 8px;
          padding-bottom: 14px;

          .additional-seats-form {
            padding-right: 48px;
          }

          .head-labels {
            .label {
              &.email {
                width: 288px !important;
              }
            }
          }

          .ps {
            max-height: calc(100vh - 550px);
          }
        }
      }
    }
  }

  .modal-footer {
    padding: 8px 40px 40px;
    @include tabletAndMobile {
      padding: 8px 20px 20px !important;
    }
    display: flex;
    align-items: inherit;
    flex-direction: column;

    .alert-message {
      position: inherit !important;
      right: 48px;
      bottom: 12px;
      font-size: 0.875rem;
      line-height: 1.5rem;
      color: $atto-red;
      font-family: $roboto-font;
      font-weight: 500;
      margin: 0;
    }

    .form-disclaimer {
      display: flex;
      flex-direction: column;
      margin-top: 26px !important;

      .top, .bottom {
        color: #666666;
        font-family: "Roboto", sans-serif;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 14px;
      }

      .bottom {
        font-size: 12px;
      }
    }

    .form-buttons {
      display: flex;
      flex-direction: row;
      margin: 0;

      .atto-btn {
        flex-grow: 1;
      }
    }

    button.submit {
      margin-right: 0;
    }

    &.sm-footer {
      align-items: flex-end;
      .form-buttons {
        .atto-btn {
          /*max-width: 160px;*/
          padding: 0;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

.discard-invite {
  z-index: 20;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -200px;
  width: 400px;
  height: 226px;
  margin-top: -113px;
  padding: 32px 32px;
  background-color: #fff;

  .field-row {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0;
  }

  p {
    margin-top: 16px;
    margin-bottom: 0;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    color: #262626;
    text-align: center;
  }

  .field-footer {
    padding: 32px 0;
    display: flex;
    flex-direction: row;

    .atto-btn {
      width: 50%;
      flex-grow: 1;
      justify-content: center;
      cursor: pointer;
      margin-right: 16px;
      padding: 6px;
      text-align: center;
      font-family: "Roboto", sans-serif;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.75rem;
      height: 40px;
    }

    .atto-btn.discard {
      margin-right: 0px;
      border: 0;
      border-radius: 0;
      width: 50%;
    }
  }
}

.links {
  background: $atto-grey;
  padding: 24px 40px 32px;
  border-top: 1px solid #efefef;
  @include tabletAndMobile {
    padding: 20px;
  }
  .deactivate-link {
    display: flex;
    justify-content: flex-end;
    @include tabletAndMobile {
      justify-content: center;
    }
  }
  .share-link {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    @include tabletAndMobile {
      flex-direction: column;
    }
    label {
      font: 500 14px/24px "Roboto", sans-serif;
      color: $atto-font-color;
      margin: 0;
    }
    .link-holder {
      width: 320px;
      @include tabletAndMobile {
        width: 100%;
        margin-bottom: 8px;
      }
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      background-color: #ffffff;
      border: 2px solid $atto-light-grey;
      img {
        margin: 11px;
      }
      input {
        width: 100%;
        height: 40px;
        border: none;
        background: transparent;
        padding-right: 30px;
        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
        color: $atto-font-color;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .copy-btn {
      background-color: $atto-font-color;
      color: #ffffff;
      text-transform: uppercase;
      width: 154px;
      @include tabletAndMobile {
        width: 100%;
      }
      height: 40px;
      margin-top: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      font: 500 16px/19px "Roboto", sans-serif;
      cursor: pointer;
    }
  }
  p {
    font: $roboto-regular 0.875rem/1.25rem $roboto-font;
    margin: 0 0 12px;
    color: $atto-not-active;
  }
  a {
    font: $roboto-medium 0.875rem/1.25rem $roboto-font;
    &.deactivate {
      color: $atto-red;
      padding: 16px 30px 0;
    }
    &.activate {
      color: $atto-green;
      padding: 16px 0 0;
    }
  }
}
</style>

<style lang="scss" scoped>
/* @media queries */
@mixin tabletAndMobile {
  @media (max-width: 767px) {
    @content;
  }
}
/* End of: @media queries */
.modal-invite-member {
  width: 586px !important;
  max-width: 586px !important;

  .modal-head {
    padding: 40px 40px 0;
    @include tabletAndMobile {
      padding: 20px !important;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;

    a.manage-team-anchor {
      position: relative;
      top: 0;
      right: 0;
    }
  }
  .modal-content {
    .modal-body {
      .content-wrapper {
        padding: 0 40px 0;
        @include tabletAndMobile {
          padding: 20px !important;
        }
        .head-labels {
          .label {
            &.email {
              margin-right: 32px;
            }
          }
        }

        .field-row {
          margin-bottom: 16px;
          .email-wrap {
            margin-right: 32px;
            @include tabletAndMobile {
              margin-right: 0;
            }
          }
          .atto-select {
            @include tabletAndMobile {
              width: 100%;
            }
            .select-heading {
              width: 154px;
              @include tabletAndMobile {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .modal-footer {
      padding: 32px 40px 40px;
      .atto-btn {
        width: 154px;
        &.cancel {
          margin-right: 32px;
        }
      }
    }
  }
}
.modal-content .content-wrapper > .ps {
  padding-right: 40px;
}
</style>
